exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/_wks-ext.js
// module id = 109
// module chunks = 0